import React, { useCallback } from "react";
import { UI } from "@wwimmo/ui";
import styles from "./AssemblyDocumentsListItem.module.css";
import { ColorStyle } from "src/utils/Colors";

interface AssemblyDocumentsListItemProps {
    fileId?: any;
    fileName?: string;
    fileDate: any;
    fileLink: string;
    isDisplayedInModal: boolean;
}

export const AssemblyDocumentsListItem = (props: AssemblyDocumentsListItemProps) => {
    const { fileId, fileName, fileDate, fileLink, isDisplayedInModal } = props;

    const handleStopPropagation = useCallback<React.MouseEventHandler<HTMLAnchorElement>>((e) => {
        e.stopPropagation();
    }, []);

    return (
        <div className={styles.ListItem} key={fileId}>
            <div className={styles.FileDetailsRow}>
                <div className={isDisplayedInModal ? styles.FileNameModal : styles.FileName}>{fileName}</div>
                <div className={styles.FileDate}>{fileDate}</div>
            </div>
            <div className={styles.DocumentsIcon}>
                <a
                    href={fileLink}
                    className={`${styles.DocumentInfoItemsContainer} link`}
                    rel="noopener noreferrer"
                    target="_blank"
                    onClick={handleStopPropagation}
                >
                    <UI.Icon icon={UI.SVGIcon.Documents} color={ColorStyle("primary")} />
                </a>
            </div>
        </div>
    );
};
